import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => {
    return {
        selectView: {
            padding: theme.spacing(2, 0),
            display: "flex",
            alignItems: "center",
            gridGap: "32px",
        },
        footerView: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            "& button": {
                marginTop: theme.spacing(5),
                height: "42px",
                width: "300px"
            },
        },
        loader: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
        }
    };
});
